
import { defineComponent, onMounted, ref } from "vue";
import { setCurrentPageTitle } from "@/core/helpers/breadcrumb";
import { useAcl } from "vue-simple-acl/dist/vue-simple-acl.vue2";
import { Modal } from "bootstrap";
import SitesTable from "@/widgets/sites-table-new/index.vue";

export default defineComponent({
  name: "Sites",

  components: {
    SitesTable,
  },

  setup() {
    const acl = useAcl();

    const filter = ref("");
    const canAdd = ref();
    const modal = ref();

    const showModal = () => {
      modal.value.show();
    };

    const setModalAcl = async () => {
      canAdd.value = await acl.can("add-site");

      if (canAdd.value) {
        modal.value = new Modal(
          document.getElementById("kt_modal_new_site"),
          {}
        );
      } else {
        modal.value = new Modal(
          document.getElementById("kt_modal_upgrade_plan"),
          {}
        );
      }
    };

    onMounted(async () => {
      setCurrentPageTitle("Sites");
      setModalAcl();
    });

    return {
      filter,
      showModal,
    };
  },

  computed: {
    placeholder() {
      return this.$t("SITES.PLACEHOLDER");
    },
  },
});
